import React from "react";
import Creatable from "react-select/creatable";

const CustomCreateLabel = ({ label }) => (
  <div
    style={{
      cursor: "pointer",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      backgroundColor: "#fff",
    }}
  >
    <span
      style={{
        background: "#2f3a79",
        color: "#fff",
        border: "none",
        borderRadius: "5px",
        padding: "8px 16px",
        fontWeight: 400,
        fontSize: "15px",
      }}
    >
      + Add {label}
    </span>
  </div>
);

const DropdownWithCreation = ({ selectProps, error = false, label = null, primary25 = null, primary = null }) => (
  <div className="sim-select">
    {label && <label>{label}</label>}
    <Creatable
      className="single-select"
      classNamePrefix="react-select"
      menuPlacement="auto"
      maxMenuHeight={200}
      menuPosition={"fixed"}
      theme={(theme) => ({
        ...theme,
        borderRadius: 5,
        colors: {
          ...theme.colors,
          primary50: primary25 || "#2f3a7950",
          primary25: primary25 || "#2f3a7950",
          primary: primary || "#2f3a7970",
          danger: "#000000",
          neutral30: "#00000050",
        },
      })}
      formatCreateLabel={(inputValue) => <CustomCreateLabel label={inputValue} />}
      onCreateOption={selectProps.func}
      {...selectProps}
    />
    <p className="error-here">{error ? error : ""}</p>
  </div>
);

export default DropdownWithCreation;
